import React from 'react';
import Button from 'src/components/Button/Button';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import './role-change-footer.scss';

export interface RoleChangeFooterProps {
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting: boolean;
  isConfirmDisabled: boolean;
}

const RoleChangeFooter = ({
  onConfirm,
  onCancel,
  isSubmitting,
  isConfirmDisabled,
}: RoleChangeFooterProps) => {
  return (
    <div className="role-change-footer">
      <Button
        color="secondary"
        size="small"
        outlined
        onClick={onCancel}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <LoadingButton
        actionText="Confirm change"
        isSubmitting={isSubmitting}
        disabled={isConfirmDisabled}
        onClick={onConfirm}
      />
    </div>
  );
};

export default RoleChangeFooter;
